<template>
  <header class="main-menu">
    <div class="container">

      <section class="main-menu__logo">
        <a href="/" class="logo">
          <img src="../assets/DNA-SIS.svg" alt="Logo" />
        </a>
        <button class="menu-toggle" @click="toggleMenu" aria-label="Toggle menu">
          <span v-if="!isMenuOpen">&#9776;</span>
          <span v-else>&times;</span>
        </button>
        <nav class="main-menu__links desktop" role="navigation" aria-label="Main menu">
          <a :class="{ active: isActiveRoute('/') }" href="/">Home</a>
          <a :class="{ active: isActiveRoute('/companies') }" href="/companies">Presenting Companies</a>
          <a :class="{ active: isActiveRoute('/venue') }" href="/venue">Venue</a>
          <a :class="{ active: isActiveRoute('/entertainment') }" href="/entertainment">Entertainment</a>
          <a :class="{ active: isActiveRoute('/agenda') }" href="/agenda">Agenda</a>
<!--          <a href="https://www.meetmax.com/sched/event_132623/investor_login.html?event_id=132623" target="_blank">1:1 Meetings</a>-->
        </nav>
      </section>
      <div
        class="overlay"
        v-if="isMenuOpen"
        @click="toggleMenu"
        aria-hidden="true"
      ></div>

      <nav class="main-menu__links mobile" :class="{ open: isMenuOpen }" role="navigation" aria-label="Main menu">
        <a :class="{ active: isActiveRoute('/') }" href="/">Home</a>
        <a :class="{ active: isActiveRoute('/companies') }" href="/companies">Presenting Companies</a>
        <a :class="{ active: isActiveRoute('/venue') }" href="/venue">Venue</a>
        <a :class="{ active: isActiveRoute('/entertainment') }" href="/entertainment">Entertainment</a>
        <a :class="{ active: isActiveRoute('/agenda') }" href="/agenda">Agenda</a>
        <a href="https://www.meetmax.com/sched/event_132623/investor_login.html?event_id=132623" target="_blank">1:1 Meetings</a>
      </nav>

    </div>
  </header>
</template>

<script>
export default {
  name: 'main menu',
  data() {
    return {
      isMenuOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    isActiveRoute(route) {
      return this.$route.path === route;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/styles/components/menu.scss';
</style>

<style lang="scss">
@import '@/styles/import/variables.scss';
@import '@/styles/import/mixins.scss';

.main-menu {
  .formcta {
    &__btn {
      padding: 7px 20px;
      @include between ($breakpoint_lg, $breakpoint_xl) {
        padding: 7px 12px;
      }
      @include upto (650px) {
        margin: 0;
        padding: 7px 40px;
      }
    }
  }
}
</style>
